import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { problemCategories } from '../../data/ultimateData';

const UltimateProblems = () => {
 const scrollToForm = () => {
 if (typeof window.fbq === 'function') {
 window.fbq('track', 'ViewContent', { content_name: 'Problem Category Click' });
 }
 const formSection = document.getElementById('contact-form-section');
 if (formSection) formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
 };

 const displayCategories = problemCategories.slice(0, 6);

 return (
 <section className="relative py-16 sm:py-24 overflow-hidden" data-testid="problems-section" id="problems-section" style={{ background: 'linear-gradient(180deg, #0B0B0E 0%, #101014 50%, #0B0B0E 100%)' }}>
 
 {/* Background Effects - Purple */}
 <div className="absolute inset-0">
 <div className="absolute top-1/4 left-0 w-96 h-96 bg-[#0B0B0E] rounded-full blur-3xl" />
 <div className="absolute bottom-1/4 right-0 w-80 h-80 bg-pink-500/10 rounded-full blur-3xl" />
 </div>
 
 <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">

 {/* Section Header */}
 <div className="text-center mb-10">
 <span className="inline-block tracking-[0.3em] text-[#C9A23A] font-bold text-sm mb-3 uppercase">
 समस्याएं
 </span>
 <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black mb-4" style={{ fontFamily: "'Rozha One', serif" }}>
 <span className="">
 क्या आप इन समस्याओं से जूझ रहे हैं?
 </span>
 </h2>
 <p className="text-[#D8D2C6] text-lg max-w-3xl mx-auto">
 अगर आप नीचे दी गई किसी भी समस्या से परेशान हैं, तो माता मलीहा के पास है आपका <span className="text-[#F3EDE2] font-bold">अचूक समाधान</span>
 </p>
 </div>

 {/* Auto-Sliding Carousel - Purple Theme */}
 <div className="max-w-5xl mx-auto">
 <Swiper
 modules={[Autoplay, Pagination]}
 spaceBetween={20}
 slidesPerView={1}
 autoplay={{
 delay: 4000,
 disableOnInteraction: false,
 }}
 pagination={{
 clickable: true,
 bulletClass: 'swiper-pagination-bullet !bg-red-700/50 !w-3 !h-3',
 bulletActiveClass: '!bg-[#d4a84b] !scale-125',
 }}
 loop={true}
 className="pb-12"
 >
 {displayCategories.map((category, index) => (
 <SwiperSlide key={index}>
 <div className="p-6 sm:p-8 rounded-3xl bg-gradient-to-br from-red-900/40 to-red-950/40 border border-[#d4a84b]/60">
 <div className="flex flex-col lg:flex-row gap-6">
 {/* Left - Info */}
 <div className="flex-1">
 {/* Icon & Title */}
 <div className="flex items-center gap-3 mb-4">
 <span className="text-4xl">{category.icon}</span>
 <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold " style={{ fontFamily: "'Rozha One', serif" }}>
 {category.title}
 </h3>
 </div>
 
 <p className="text-[#D8D2C6] mb-4 text-sm sm:text-base">{category.subtitle}</p>
 
 {/* Symptoms Preview */}
 <div className="mb-4">
 <h4 className="text-[#F3EDE2] font-bold mb-2 text-sm">लक्षण:</h4>
 <div className="space-y-1">
 {category.symptoms?.slice(0, 4).map((symptom, i) => (
 <div key={i} className="flex items-start gap-2">
 <span className="text-[#7a2929] mt-0.5">•</span>
 <span className="text-[#D8D2C6]/90 text-xs sm:text-sm">{symptom}</span>
 </div>
 ))}
 </div>
 </div>
 
 {/* Stats */}
 <div className="flex flex-wrap gap-2">
 <span className="px-3 py-1 rounded-full bg-[#250808] border border-green-500/40 text-[#0a5e3a] text-xs font-bold">
 {category.successRate} सफलता
 </span>
 <span className="px-3 py-1 rounded-full bg-red-700/20 border border-[#d4a84b]/40 text-[#D8D2C6] text-xs font-bold">
 {category.duration}
 </span>
 <span className="px-3 py-1 rounded-full bg-[#0B0B0E] border border-[#d4a84b]/40 text-[#F3EDE2] text-xs font-bold">
 क्षमतानुसार दक्षिणा
 </span>
 </div>
 </div>

 {/* Right - CTA */}
 <div className="lg:w-72 p-5 rounded-2xl bg-[#17171C] shadow-md border border-[#d4a84b]/30 text-center">
 <p className="text-[#7a2929] font-bold mb-3 text-sm sm:text-base">{category.urgencyText}</p>
 <button
 onClick={scrollToForm}
 className="w-full py-3 text-base sm:text-lg font-black rounded-xl hover:scale-105 transition-all mb-3" style={{ background: 'linear-gradient(135deg, #6E0F0F, #A31515)', color: '#F5E7C8', border: '1.5px solid #C9A23A', boxShadow: '0 6px 20px rgba(163,21,21,0.45)', fontFamily: "'Rozha One', serif" }}
 >
 जांच करवाएं - क्षमतानुसार
 </button>
 <p className="text-[#D8D2C6]/70 text-xs">माता जी सिर्फ नाम से सब बता देंगी</p>
 </div>
 </div>
 </div>
 </SwiperSlide>
 ))}
 </Swiper>
 </div>

 {/* Bottom CTA */}
 <div className="text-center mt-8">
 <p className="text-[#D8D2C6] mb-4">आपकी समस्या list में नहीं है? चिंता न करें!</p>
 <button
 onClick={scrollToForm}
 className="px-8 py-3 bg-gradient-to-r from-[#f5d77e] to-[#d4a84b] text-black text-lg font-black rounded-full shadow-xl shadow-amber-500/30 hover:scale-105 transition-all"
 style={{ fontFamily: "'Rozha One', serif" }}
 >
 अपनी समस्या बताएं - क्षमतानुसार जांच
 </button>
 </div>
 </div>
 </section>
 );
};

export default UltimateProblems;
